import { render, staticRenderFns } from "./OnboardCardholders.vue?vue&type=template&id=379d3a4d"
import script from "./OnboardCardholders.vue?vue&type=script&lang=js"
export * from "./OnboardCardholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports